import { apiPrefix, ConnectionService, httpMethodType } from "./Connecion.service";

const RESOURCE = 'auth/StoreTag';

class AuthStoreTagService extends ConnectionService {

  constructor () {
    super();
    this.basedUrl = `${apiPrefix}/${RESOURCE}`;
  }

  async createSiteTag (data) {
    const url = `${this.basedUrl}`;
    const config = {
      method: httpMethodType.post,
      body: JSON.stringify(data)
    };
    return super.sendRequest(url, config, true);
  }

  async updateSiteTag (tagId, data) {
    const url = `${this.basedUrl}/${tagId}`;
    const config = {
      method: httpMethodType.put,
      body: JSON.stringify(data)
    };
    return super.sendRequest(url, config, true);
  }

  async addTag (parentId, data) {
    const url = `${this.basedUrl}/${parentId}/addTag`;
    const config = {
      method: httpMethodType.post,
      body: JSON.stringify(data)
    };
    return super.sendRequest(url, config, true);
  }

  async removeTag (parentId, data) {
    const url = `${this.basedUrl}/${parentId}/removeTag`;
    const config = {
      method: httpMethodType.post,
      body: JSON.stringify(data)
    };
    return super.sendRequest(url, config, true);
  }

  async moveTag (parentId, data) {
    const url = `${this.basedUrl}/${parentId}/moveTag`;
    const config = {
      method: httpMethodType.post,
      body: JSON.stringify(data)
    };
    return super.sendRequest(url, config, true);
  }

  async asyncDeleteTag (tagId) {
    const url = `${this.basedUrl}/${tagId}/asyncDelete`;
    const config = {
      method: httpMethodType.delete
    };
    return super.sendRequest(url, config, true);
  }

  async addStore (tagId, data) {
    const url = `${this.basedUrl}/${tagId}/addStore`;
    const config = {
      method: httpMethodType.post,
      body: JSON.stringify(data)
    };
    return super.sendRequest(url, config, true);
  }

  async removeStore (tagId, data) {
    const url = `${this.basedUrl}/${tagId}/removeStore`;
    const config = {
      method: httpMethodType.post,
      body: JSON.stringify(data)
    };
    return super.sendRequest(url, config, true);
  }

  async moveStore (tagId, data) {
    const url = `${this.basedUrl}/${tagId}/moveStore`;
    const config = {
      method: httpMethodType.post,
      body: JSON.stringify(data)
    };
    return super.sendRequest(url, config, true);
  }

}

export default new AuthStoreTagService();